import { buildUpdatePromotionCreditFormSchema } from './build-update-form-schema.js';
export const updatePromotionCreditFormSchema = buildUpdatePromotionCreditFormSchema();
//# sourceMappingURL=update-form.js.map